<template>
  <div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">评论</li>
    </ol>
    <div class="am-scrollable-horizontal">
      <table class="am-table am-table-hover am-text-nowrap">
        <thead>
        <tr>
          <th>ID</th>
          <th>评论内容</th>
          <th>评论时间</th>
          <th>操作</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="comment in commentList">
          <tr>
            <td>{{comment.id}}</td>
            <td class="am-text-normal">
              <span v-if="comment.status===2" class="am-badge am-badge-warning am-radius">匿名</span>
              <span v-if="comment.status===3" class="am-badge am-badge-danger am-radius">悄悄话</span>
              <span>
                <b>
                  <router-link :to="{path:`/edit/users?userId=${comment.authorId}`}">{{comment.authorName}}[{{comment.authorId}}]</router-link>:
                </b>
              </span>
              <span v-html="comment.content"></span>
              <router-link :to="{path:`/post/${comment.sceneId}?commentId=${comment.id}`}" v-if="comment.sceneType===1">
                <span class="am-icon-external-link"> </span>
              </router-link>
              <router-link :to="{path:`/${comment.pageSlug}?commentId=${comment.id}`}" v-else>
                <span class="am-icon-external-link"> </span>
              </router-link>
            </td>
            <td>{{comment.createTime}}</td>
            <td>
              <button class="am-btn am-btn-link" @click="deleteComment(comment.id)">删除</button>
            </td>
          </tr>
          <tr v-for="child in comment.children">
            <td>- {{child.id}}</td>
            <td class="am-text-normal">
              <span v-if="child.status===2" class="am-badge am-badge-warning am-radius">匿名</span>
              <span v-if="child.status===3" class="am-badge am-badge-danger am-radius">悄悄话</span>
              <span v-if="child.rootId===child.commentId">
                <b>
                  <router-link :to="{path:`/edit/users?userId=${child.authorId}`}">{{child.authorName}}[{{child.authorId}}]</router-link>:
                </b>
              </span>
              <template v-else>
                <b>
                  <router-link :to="{path:`/edit/users?userId=${child.authorId}`}">{{child.authorName}}[{{child.authorId}}]</router-link>
                </b>
                回复
                <b>
                  <router-link :to="{path:`/edit/users?userId=${child.ownerId}`}">{{child.ownerName}}[{{child.ownerId}}]</router-link>:
                </b>
              </template>
              <span v-html="child.content"></span>
              <router-link :to="{path:`/post/${child.sceneId}?commentId=${child.id}`}" v-if="child.sceneType===1">
                <span class="am-icon-external-link"> </span>
              </router-link>
              <router-link :to="{path:`/${child.pageSlug}?commentId=${child.id}`}" v-else>
                <span class="am-icon-external-link"> </span>
              </router-link>
            </td>
            <td>{{child.createTime}}</td>
            <td>
              <button class="am-btn am-btn-link" @click="deleteComment(child.id)">删除</button>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
    <ol class="am-breadcrumb">
      <li>
        <router-link :to="{path:'/edit'}" class="am-icon-home">控制台</router-link>
      </li>
      <li class="am-active">管理</li>
      <li class="am-active">评论</li>
    </ol>
  </div>
</template>

<script>
import { adminCommentGetList, adminCommentDelete } from '@/request'
import {MessageBox, Toast} from "mint-ui"
export default {
  name: 'EditComments',
  data () {
    return {
      commentList: []
    }
  },
  mounted () {
    this.loadCommentList()
  },
  methods: {
    loadCommentList () {
      adminCommentGetList().then(res => {
        this.commentList = res
      })
    },
    deleteComment(id) {
      MessageBox.confirm('确定删除吗？').then(() => {
        adminCommentDelete({id}).then(() => {
          this.loadCommentList()
          Toast('删除成功')
        })
      })
    }
  }
}
</script>

<style>
.bq {
  width: 2.5rem;
  height: 2.5rem;
  position: relative;
  bottom: .5rem;
  display: inline-block!important;
}
.am-text-normal {
  white-space: normal;
  min-width: 300px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/EditComments.vue